import React from "react";
import { Button, useTheme } from "@tvg/design-system";
import { NavigationContainer } from "./styled-components";

interface Props {
  qaLabel?: string;
  totalLegs: number;
  currentLeg: number;
  onSelectBetLeg?: (leg: number) => void;
}

const MobilePicksNavigation = ({
  qaLabel = "mobile-picks-navigation",
  totalLegs,
  currentLeg,
  onSelectBetLeg
}: Props) => {
  const { colors } = useTheme();
  return (
    <NavigationContainer colors={colors} data-qa-label={qaLabel}>
      {currentLeg > 0 && (
        <Button
          variant="tertiary"
          qaLabel={`${qaLabel}-prev`}
          icon="arrowLeft"
          iconPosition="start"
          onPress={() => onSelectBetLeg?.(currentLeg - 1)}
        >
          Previous Leg
        </Button>
      )}
      {currentLeg < totalLegs - 1 && (
        <Button
          variant="tertiary"
          qaLabel={`${qaLabel}-next`}
          icon="arrowRight"
          iconPosition="end"
          ml="auto"
          onPress={() => onSelectBetLeg?.(currentLeg + 1)}
        >
          Next Leg
        </Button>
      )}
    </NavigationContainer>
  );
};

export default MobilePicksNavigation;
